import RefPoli from "@/services/bridgingVclaim/RefPoli";
// import UserLogin from "@/utility/User";


import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";

@Module({ store, dynamic: true, name: "storeRefPoli" })
class RefPoliStore extends VuexModule {
  refPoli = [];

  @Mutation SET_REF_POLI(refPoli) {
    this.refPoli = refPoli;
  }

  @Action getListPoli() {
    const dt = RefPoli.getRefPoli()
    dt.then(dt => {
      const refPoli = dt.data
      this.SET_REF_POLI(refPoli);
    });
  }


}

export const storeRefPoli = getModule(RefPoliStore);
